import {Loader} from "../../pages/ChatPage/MessagesList/styles";
import React from "react";

interface ISmallLoader {
    height: number;
    color: string;
    borderWidth?: number;
    minWidth?: number;
}

export const SmallLoader: React.FC<ISmallLoader> = (props) => {
   return <Loader style={{width: props.minWidth}} {...props}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </Loader>
}